/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import "../styles/navbar.css";
// @ts-ignore
import githubIcon from "../assets/icons8-github.svg";
// @ts-ignore
import zhihuIcon from "../assets/zhihu_icon.svg";
import twitterIcon from "../assets/twitter_icon.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navbar: React.FunctionComponent = () => {
  let location = useLocation();
  const logoImg = require("../assets/Logo_transparent_bg.png") as string;
  const [activePage, setActivePage] = useState("home");
  const navigate = useNavigate();

  useEffect(() => {
    let locationStr = location.pathname.slice(1);

    if (locationStr === "") {
      setActivePage("home");
    } else {
      setActivePage(locationStr);
    }
  }, [location.pathname]);

  return (
    <div className="nav-container">
      <div
        className="brand-image-container"
        onClick={() => {
          setActivePage("home");
          navigate("/");
        }}
      >
        <img src={logoImg} alt="brand image" className="brand-image" />
      </div>

      <ul className="nav-link-container">
        <li className="nav-link" onClick={() => setActivePage("home")}>
          <Link to={"/"} className={activePage === "home" ? "active" : ""}>
            HOME
          </Link>
        </li>

        <li>
          <div className="dropdown">
         
           <Link className="dropdown-toggle nav-link" data-bs-toggle="dropdown" aria-expanded="false">
              SERVICE
            </Link>
        
            <ul className="dropdown-menu">
              <li className="dropdown-content-links">
                <Link className="dropdown-content-links" to="/service">
                  Agent Training
                </Link>
              </li>
              <hr />
              <li className="dropdown-content-links">
              <Link className="dropdown-content-links" to="/Finagent">
                AT Agent - FinAgent
              </Link>
            </li>
              <hr />
              <li className="dropdown-content-links">
                <Link className="dropdown-content-links" to="/MacroHFT">
                  Crypto - MacroHFT
                </Link>
              </li>


              <hr />
              <li className="dropdown-content-links">
                <Link className="dropdown-content-links" to="/EarnHFT">
                  Crypto - EarnHFT
                </Link>
              </li>

              <hr />
              <li className="dropdown-content-links">
                <Link className="dropdown-content-links" to="/EarnMore">
                  Portfolio - EarnMore
                </Link>
              </li>
              <hr />
              <li className="dropdown-content-links">
                <Link className="dropdown-content-links" to="/evaluation-toolbox">
                  Sandbox - Market Dynamics Modeling
                </Link>
              </li>
              <hr />
              <li className="dropdown-content-links">
                <Link className="dropdown-content-links" to="/MarketGAN">
                  Sandbox - Market Simulator
                </Link>
              </li>
            </ul>
          </div>
        </li>

        {/* <li
          className="nav-link dropdown"
          onClick={() => setActivePage("service")}
        >
          <Link
            className={
              activePage === "service" || activePage === "evaluation-toolbox" || activePage === "MarketGAN"
                ? "active"
                : ""
            }
          >
            SERVICE
            <span className="caret"></span>
          </Link>
          <ul className="dropdown-content" style={{ marginTop: '0' }}>
            <li className="dropdown-content-links">
              <Link className="dropdown-content-links" to="/service">
                Agent Training
              </Link>
            </li>
            <hr />
            <li className="dropdown-content-links">
              <Link className="dropdown-content-links" to="/EarnHFT">
                Crypto - EarnHFT
              </Link>
            </li>
            <hr />
            <li className="dropdown-content-links">
              <Link className="dropdown-content-links" to="/EarnMore">
                Portfolio- EarnMore
              </Link>
            </li>
            <hr />
            <li className="dropdown-content-links">
              <Link className="dropdown-content-links" to="/evaluation-toolbox">
                Sandbox- Market Dynamics Modeling
              </Link>
            </li>
            <hr />
            <li className="dropdown-content-links">
              <Link className="dropdown-content-links" to="/MarketGAN">
                Sandbox- Market Simulator
              </Link>
            </li>
          </ul>
        </li> */}



        <li className="nav-link" onClick={() => setActivePage("projects")}>
          <Link
            to={"/research"}
            className={activePage === "research" ? "active" : ""}
          >
            RESEARCH
          </Link>
        </li>
        <li className="nav-link" onClick={() => setActivePage("contact")}>
          <Link
            to={"/contact"}
            className={activePage === "contact" ? "active" : ""}
          >
            CONTACT US
          </Link>
        </li>
      </ul>

      <ul className="icon-container">
        <li className="icon-link">
          <a
            href="https://github.com/TradeMaster-NTU/TradeMaster"
            target="_blank"
            rel="noreferrer"
          >
            <img src={githubIcon} alt="github Icon" className="icon" />
          </a>
        </li>
        <li className="icon-link">
          <a
            href="https://www.zhihu.com/people/trademaster-22"
            target="_blank"
            rel="noreferrer"
          >
            <img src={zhihuIcon} alt="zhihu icon" className="icon" />
          </a>
        </li>
        <li className="icon-link">
          <a
            href="https://twitter.com/NtuTrademaster"
            target="_blank"
            rel="noreferrer"
          >
            <img src={twitterIcon} alt="twitter icon" className="icon" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
